import { NavLink, Outlet } from 'react-router-dom'
import { useState } from 'react'

import { useAuth } from '../../auth/AuthContext.js'
import { Button, PreferencesPanel, SignOutButton } from '../../components'
import styles from './StudentLayout.module.css'

export default function StudentLayout(): JSX.Element {
  const { email, uid } = useAuth()
  const [preferencesOpen, setPreferencesOpen] = useState(false)

  return (
    <div className={styles.shell}>
      <header className={styles.topbar}>
        <div className={styles.brandBlock}>
          <p className={styles.eyebrow}>Study Decks</p>
          <h1>Student Home</h1>
        </div>
        <nav aria-label="Student navigation" className={styles.nav}>
          <NavLink
            to="/student"
            end
            className={({ isActive }) =>
              [styles.navLink, isActive ? styles.navLinkActive : ''].filter(Boolean).join(' ')
            }
          >
            Home
          </NavLink>
        </nav>
        <div className={styles.sessionCard}>
          <div>
            <p className={styles.sessionLabel}>Signed in as</p>
            <p className={styles.sessionValue}>{email ?? 'Student account'}</p>
          </div>
          <div className={styles.sessionActions}>
            <Button type="button" variant="secondary" onClick={() => setPreferencesOpen(true)}>
              Display & accessibility
            </Button>
            <SignOutButton />
          </div>
        </div>
      </header>
      <main id="main-content" className={styles.main}>
        <Outlet />
      </main>
      <PreferencesPanel
        open={preferencesOpen}
        uid={uid}
        onClose={() => setPreferencesOpen(false)}
      />
    </div>
  )
}
